import { ofType } from 'redux-observable';
import { from } from 'rxjs/observable/from';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';

import { retryAuthentication } from '../../utils/epics/retryAuthentication';

import {
  types as actions,
  setAreasAction,
  setCurrentAreaAction,
} from '../../reducers/actions';
import { AreaService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_AREAS),
    switchMap(action => {
      return AreaService.getBySiteId(action.siteId, store).pipe(
        switchMap(data => {
          let { siteId, loadChildren, ignoreFile } = action;
          let currentAreaId = localStorage.getItem(`airfinder_selected_area`);
          let currentArea =
            data.find(area => area.id === currentAreaId) || data[0];
          if(!currentArea){
            currentArea = {}
          }
          let setCurrentArea = setCurrentAreaAction(currentArea, loadChildren, ignoreFile);
          return from([
            setCurrentArea,
            setAreasAction(siteId, data),
          ]);
        }),
        catchError(retryAuthentication(action$, 'epics/areas/getAreas'))
      );
    })
  );
}


// WEBPACK FOOTER //
// ./src/epics/areas/getAreas.js